// Enhanced medieval-themed color palettes

export const lightTheme = {
  "--background": "#0d0a08", // same as candlelight - very dark medieval hall
  "--text": "#f5e6c8", // same as candlelight - warm candlelight text
  "--primary": "#cd853f", // same as candlelight - golden bronze
  "--accent": "#ffb347", // same as candlelight - warm peach gold
  "--panel": "#1a1612", // same as candlelight - dark panels
  "--scroll": "#8b7355", // same as candlelight - bronze scroll edge
  "--shadow": "0 8px 32px rgba(0, 0, 0, 0.6)", // same as candlelight
  "--hover": "#b8860b", // same as candlelight - darker gold hover
  "--muted": "#d2b48c", // same as candlelight - tan for muted text
  "--success": "#32cd32", // same as candlelight - lime green
  "--warning": "#ff6347", // same as candlelight - tomato
};

export const candlelightTheme = {
  "--background": "#0d0a08", // very dark medieval hall
  "--text": "#f5e6c8", // warm candlelight text
  "--primary": "#cd853f", // golden bronze
  "--accent": "#ffb347", // warm peach gold
  "--panel": "#1a1612", // dark panels
  "--scroll": "#8b7355", // bronze scroll edge
  "--shadow": "0 8px 32px rgba(0, 0, 0, 0.8)",
  "--hover": "#b8860b", // darker gold hover
  "--muted": "#d2b48c", // tan for muted text
  "--success": "#32cd32", // lime green
  "--warning": "#ff6347", // tomato
};
